export const APP_STATE_LOADED_SUCCESSFULLY = 'APP_STATE_LOADED_SUCCESSFULLY';

export const TRANSACTION_FAILED_MODAL_TRIGGER =
  'TRANSACTION_FAILED_MODAL_TRIGGER';
export const CVV_MODAL_TRIGGER = 'CVV_MODAL_TRIGGER';
export const EXPIRY_DATE_MODAL_TRIGGER = 'EXPIRY_DATE_MODAL_TRIGGER';

export const METADATA_LOADING = 'METADATA_LOADING';
export const METADATA_LOADED_SUCCESSFULLY = 'METADATA_LOADED_SUCCESSFULLY';

export const CHECKOUT_LOADING = 'CHECKOUT_LOADING';
export const UPDATE_METADATA = 'UPDATE_METADATA';
